export const azureReconciliationPaths = {
  get: (connectionId) =>
    `/compute/cloud-account-connections/${encodeURIComponent(connectionId)}/azure/reconciliation`,
};
